/* eslint-disable no-console */
/* eslint-disable react/jsx-props-no-spreading */
import { Box, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import AutoCompleteDropdown from "../../../components/common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import DateRangePicker from "../../../components/common/DateRangePicker/DateRangePicker";
import DropDownSelect from "../../../components/common/Dropdown";
import MultiSelectDropdown from "../../../components/common/DropdownMultiSelectNew";
// import SwitchButton from "../../../components/common/SwitchButton";
// import useQueryParams from "../../../hooks/useQueryParams";
import useParamsQuery from "../../../hooks/useParamsQuery";
import {
  SET_POSITIONS,
  SET_PROFESSIONS,
} from "../../../redux/actionTypes/meta";
import IntroductionForm from "../../../services/api/introductionForm";
import { isEmptyObj } from "../../../utils/helper";
// import styles from "./SearchForm/SearchForm.styles";
import { MAINLINE_POSITION_KEY, POSITIONS_KEY } from "./utils";
import { getOptions } from "../../../utils";

const MAINLINE_POSITION = "MAINLINE_POSITION";
const DEPUTY_POSITION = "DEPUTY_POSITION";

const initialFormValue = {
  dateOfBirthFrom: "",
  dateOfBirthTo: "",
  dateOfJoiningFrom: "",
  dateOfJoiningTo: "",
  appointedAtFrom: "",
  appointedAtTo: "",
  conferralDateFrom: "",
  conferralDateTo: "",
};

function AdvancedSearch() {
  // const [isGohonzonMember, setIsGohonzonMember] = useState(false);
  // const [isOmamoriGohonzonMember, setIsOmamoriGohonzonMember] = useState(false);
  // const [unsubscribe, setUnsubscribe] = useState(false);
  const [initialAdvanceFormValue, setInitialAdvanceFormValue] =
    useState(initialFormValue);
  const { getQueryObject, getQueryParams, urlSearchParams } = useParamsQuery();
  const [positions, setPositions] = useState([]);
  const [mainlinePositions, setMainlinePositions] = useState([]);
  const [selectedPositions, setSelectedPositions] = useState([]);
  const [selectedMainlinePositions, setSelectedMainlinePositions] = useState(
    []
  );
  const [selectedGohonzonTypes, setSelectedGohonzonTypes] = useState([]);
  const gohonzonTypeOptions = [
    { entityTitle: "Okataki gohonzon", value: "OKATAKI_GOHONZON" },
    { entityTitle: "Omamori gohonzon", value: "OMAMORI_GOHONZON" },
  ];
  const [profession, setProfession] = useState([]);
  const [selectedProfession, setSelectedProfession] = useState("");
  const dispatch = useDispatch();
  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      console.log(queryObject);
      const query = getQueryParams(queryObject)[0];
      Object.keys(initialFormValue).forEach((key) => {
        setInitialAdvanceFormValue((prev) => ({
          ...prev,
          [key]: query[key] ?? "",
        }));
      });

      // positions
      if (queryObject?.MAINLINE_POSITION) {
        [MAINLINE_POSITION_KEY].forEach((key) => {
          console.log(query[key]);
          if (query[key]) {
            const positionsInNumber = query[key].split(",").map(Number);
            console.log("line 72", positionsInNumber);
            setSelectedMainlinePositions([...positionsInNumber]);
          }
        });
      }
      if (queryObject.POSITIONS_KEY) {
        [POSITIONS_KEY].forEach((key) => {
          console.log(query[key]);
          if (query[key]) {
            const positionsInNumber = query[key].split(",").map(Number);
            console.log("line 72", positionsInNumber);
            setSelectedPositions([...positionsInNumber]);
          }
        });
      }
      // [POSITIONS_KEY].forEach((key) => {
      //   console.log(query[key]);
      //   if (query[key]) {
      //     const positionsInNumber = query[key].split(",").map(Number);
      //     console.log("line 72", positionsInNumber);
      //     setSelectedPositions([...positionsInNumber]);
      //   }
      // });
      // [MAINLINE_POSITION_KEY].forEach((key) => {
      //   console.log(query[key]);
      //   if (query[key]) {
      //     const positionsInNumber = query[key].split(",").map(Number);
      //     console.log("line 72", positionsInNumber);
      //     setSelectedMainlinePositions([...positionsInNumber]);
      //   }
      // });
    } else {
      setInitialAdvanceFormValue(initialFormValue);
      setSelectedPositions([]);
      setSelectedMainlinePositions([]);
    }
    // setSelectedGohonzonTypes([]);
  }, [urlSearchParams.toString()]);

  const getPositions = async () => {
    try {
      const [mainlinePositionsRes, othersPositionRes] = await Promise.all([
        IntroductionForm.getAllPositions(MAINLINE_POSITION),
        IntroductionForm.getAllPositions(DEPUTY_POSITION),
      ]);

      const mainlineFormattedPos =
        mainlinePositionsRes?.data?.map((d) => ({
          entityTitle: d.name,
          value: d.positionId,
        })) ?? [];

      const othersFormattedPos =
        othersPositionRes?.data?.map((d) => ({
          entityTitle: d.name,
          value: d.positionId,
        })) ?? [];

      setMainlinePositions(mainlineFormattedPos);
      setPositions(othersFormattedPos);
      const allPositions = [...mainlineFormattedPos, ...othersFormattedPos];

      if (allPositions.length) {
        dispatch({
          type: SET_POSITIONS,
          payload: allPositions,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  console.log({ selectedMainlinePositions, selectedPositions });
  const setMetaDataInRedux = (type, payload) => {
    dispatch({
      type,
      payload,
    });
  };
  const getProfessions = async () => {
    const response = await IntroductionForm.getProfessions();
    setProfession(response.data);
    setMetaDataInRedux(SET_PROFESSIONS, response.data);
  };

  useEffect(() => {
    getPositions();
    getProfessions();
  }, []);

  // const mainlineDropdownId = "mainline-positions-dropdown";
  // const positionsDropdownId = "other-positions-dropdown";
  return (
    <Box sx={{ width: "100%" }}>
      <Grid container rowSpacing={4} columnSpacing={5}>
        <Grid item xs={6}>
          <DateRangePicker
            label="Date of Birth"
            name="dateOfBirth"
            startDateVal={initialAdvanceFormValue.dateOfBirthFrom}
            endDateVal={initialAdvanceFormValue.dateOfBirthTo}
          />
        </Grid>
        <Grid item xs={6}>
          <DateRangePicker
            label="Date of Joining"
            name="dateOfJoining"
            startDateVal={initialAdvanceFormValue.dateOfJoiningFrom}
            endDateVal={initialAdvanceFormValue.dateOfJoiningTo}
          />
        </Grid>
        <Grid item xs={6}>
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.profession}
            options={getOptions(profession, "professionsId")}
            label="Profession"
            name="professionsId"
            value={selectedProfession}
            onChange={(selectedValue) => {
              setSelectedProfession(selectedValue.value);
            }}
            inputProps={{ required: false }}
            useHiddenInput
            // disabled
          />
        </Grid>

        {/* <Grid item xs={6}>
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.cityName}
            label="Profession Special Group"
            name="professionSpecialGroup"
            inputProps={{ required: false }}
            useHiddenInput
            disabled
          />
        </Grid> */}

        <Grid item xs={6} />
        <Grid item xs={6}>
          {/* <AutoCompleteDropdown
            label="Mainline Leadership Position"
            name="leadershipPosition"
            inputProps={{ required: false }}
            useHiddenInput
            disabled
          /> */}
          <MultiSelectDropdown
            title="Mainline Leadership Position"
            name="mainlinePositionIds"
            multiple
            selectOptions={mainlinePositions}
            value={selectedMainlinePositions}
            setValue={setSelectedMainlinePositions}
            style={{ maxWidth: 290 }}
            className="dropdown-multiple"
            id="mainlineDropdownId"
          />
        </Grid>
        <Grid item xs={6}>
          <MultiSelectDropdown
            title="Other Positions"
            name="dualPositionIds"
            multiple
            selectOptions={positions}
            value={selectedPositions}
            setValue={setSelectedPositions}
            style={{ maxWidth: 290 }}
            className="dropdown-multiple"
            id="positionsDropdownId"
          />
        </Grid>
        <Grid item xs={6}>
          <DateRangePicker
            label="Appointment Date"
            name="appointedAt"
            // disabled
            startDateVal={initialAdvanceFormValue.appointedAtFrom}
            endDateVal={initialAdvanceFormValue.appointedAtTo}
          />
        </Grid>
        <Grid item xs={6} />
        {/* <Grid item xs={6}>
          <AutoCompleteDropdown
            label="Subdivision Leadership Position"
            name="subLeadershipPosition"
            inputProps={{ required: false }}
            useHiddenInput
            disabled
          />
        </Grid> */}
        {/* <Grid item xs={6}>
          <DateRangePicker
            label="Sub-Division Appointment Date"
            name="subDivisionAppointment"
            disabled
          />
        </Grid> */}
        {/* <Grid item xs={6}>
          <Typography style={styles.switchLabel}>Gohonzon Member</Typography>
          <SwitchButton
            value={isGohonzonMember}
            name="isGohonzon"
            handleChange={() => setIsGohonzonMember((prev) => !prev)}
            disabled
          />
        </Grid> */}
        <Grid item xs={6}>
          <DropDownSelect
            title="Gohonzon Type"
            name="gohonzonTypes"
            multiple
            selectOptions={gohonzonTypeOptions}
            value={selectedGohonzonTypes}
            setValue={setSelectedGohonzonTypes}
            // style={{ maxWidth: 290 }}
            className="dropdown-multiple"
          />
        </Grid>
        <Grid item xs={6}>
          <DateRangePicker
            label="Conferral Date"
            name="conferralDate"
            startDateVal={initialAdvanceFormValue.conferralDateFrom}
            endDateVal={initialAdvanceFormValue.conferralDateTo}
          />
        </Grid>
        {/* <Grid item xs={6}>
          <Typography style={styles.switchLabel}>Omamori Gohonzon</Typography>
          <SwitchButton
            value={isOmamoriGohonzonMember}
            name="isOmamoriGohonzon"
            handleChange={() => setIsOmamoriGohonzonMember((prev) => !prev)}
            disabled
          />
        </Grid> */}
        {/* <Grid item xs={6}>
          <Typography style={styles.switchLabel}>
            Unsubscribe (Wrong Email ID)
          </Typography>
          <SwitchButton
            name="unsubscribe"
            value={unsubscribe}
            handleChange={() => setUnsubscribe((prev) => !prev)}
            disabled
          />
        </Grid> */}
      </Grid>
    </Box>
  );
}

export default AdvancedSearch;
